import { getStatusPresentation } from '@lib/social/scheduling/posts';
import { showToast } from '@lib/utils/toastmaster';
import { socialScheduleStore } from '@stores/SocialSchedule';

/**
 * The one response to a 409 `not_editable` / `not_cancellable` /
 * `not_retryable`: the post moved under the user (the worker claimed it, or
 * another tab acted), so reload it and say what it is now. Every entry point
 * that can receive the 409 (save, cancel, retry) calls this.
 */
export const notifyStatusConflict = async (postId: string): Promise<void> => {
  // Name the status only from a read issued after the 409; a held copy is the one the user just acted on.
  const landed = await socialScheduleStore.loadPost(postId);
  const status = landed ? socialScheduleStore.post(postId)?.status : undefined;
  showToast('social-post-status-changed', {
    statusLabel: status ? getStatusPresentation(status).label : 'different',
  });
};
